import I18NextVue from 'i18next'

const { t, language } = I18NextVue

const options = { ns: language }

export function translate(key: string, interpolation?: Record<string, unknown>) {
  return (t as (_translationKey: string, _translationOptions: typeof options) => string)(
    key,
    interpolation ? { ...options, ...interpolation } : options,
  )
}
